import { createSlice } from '@reduxjs/toolkit';

export type SiteMenuState = { open: boolean };
export type SiteMenuRootState = { siteMenu: SiteMenuState };

const initialState: SiteMenuState = { open: false };
const slice = createSlice({
  name: 'siteMenu',
  initialState,
  reducers: {
    opened(state) {
      state.open = true;
    },
    closed(state) {
      state.open = false;
    },
  },
});

export const siteMenuReducer = slice.reducer;
export const siteMenuActions = slice.actions;
